import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import AesMixin from '@/helpers/vue_mixins/v2/AesMixin';
import FacebookLogin from '@/plugins/graphql/mutations/facebook-login.gql';
import SignInBasic from '@/plugins/graphql/mutations/v2/auth/sign-in-cms-email.gql';
import AuthMixin from '@/helpers/vue_mixins/v2/AuthMixin';
import { FacebookLoginProvider } from '@/helpers/entities/classes/providers/FacebookLoginProvider';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import { fbSessionKeys } from '@/helpers/FbSession';
// Initialize class FacebookLoginProvider
// Ref: ./FbLoginButton.vue
const Provider = new FacebookLoginProvider();
let HelpCenterWidget = class HelpCenterWidget extends Mixins(AuthMixin, ButtonLoaderMixin, AlertMixin, AesMixin) {
    constructor() {
        super(...arguments);
        this.menu = false;
        this.isHelpCenter = false;
        this.togglePasswordDialog = false;
        this.toggleConfirmDialog = false;
    }
    get cmsHelpCenterMenuList() {
        return [
            {
                link: 'https://www.youtube.com/channel/UCfI5QDh8PmAiU0outNApCkA',
                external: true,
                text: 'Youtube Channel',
                icon_path: require('@/assets/images/help-youtube.svg'),
            },
            {
                link: 'https://blog.chatgenie.ph/',
                external: true,
                text: 'Blog',
                icon_path: require('@/assets/images/help-blog.svg'),
            },
            {
                link: 'https://chatgenie.ph/sales-partner',
                external: true,
                text: 'Hire An Agency',
                icon_path: require('@/assets/images/help-office.svg'),
            },
            {
                link: 'https://www.facebook.com/groups/648571835727369',
                external: true,
                text: 'Join The Community',
                icon_path: require('@/assets/images/help-community.svg'),
            },
        ];
    }
    hideConfirmationDialog() {
        this.toggleConfirmDialog = false;
    }
    onShowPermissionDialog() {
        this.toggleConfirmDialog = true;
        this.menu = false;
    }
    reauthenticateUserFacebook() {
        if (!fbSessionKeys().length) {
            this.togglePasswordDialog = true;
            this.hideConfirmationDialog();
            return;
        }
        this.requestOnFlight();
        Provider.signIn()
            .then((response) => {
            const token = response.authResponse.accessToken;
            this.resetFbToken(token, this.role);
            this.successNotification('Permissions have been reset successfully. Reauthenticating...');
            this.hideConfirmationDialog();
        })
            .catch((e) => {
            this.errorNotification(e.message);
            this.requestDone();
            this.hideConfirmationDialog();
        });
    }
    resetToken(email, password) {
        this.requestOnFlight();
        this.$apollo
            .mutate({
            mutation: SignInBasic,
            variables: {
                input: { email: this.encrypt(email), password: this.encrypt(password), role: this.role },
            },
        })
            .then(({ data }) => {
            const { jwt } = data.signInCmsEmail;
            this.successNotification('User reauthenticated');
            this.$router.push('/apps');
            this.requestDone();
            this.togglePasswordDialog = false;
            this.authenticate(jwt, this.role);
            this.resetClient(jwt);
        })
            .catch((e) => {
            this.requestDone();
            this.errorNotification(e.message);
            this.togglePasswordDialog = false;
        });
    }
    resetFbToken(token, role) {
        this.$apollo
            .mutate({
            mutation: FacebookLogin,
            variables: { token: this.encrypt(token), role },
        })
            .then(({ data }) => {
            const { jwt } = data.facebookLogin;
            this.requestDone();
            this.hideConfirmationDialog();
            this.successNotification('User reauthenticated');
            this.authenticate(jwt, role);
            this.resetClient(jwt);
            this.$router.push('/apps');
        })
            .catch((e) => {
            this.errorNotification(e.message);
            this.requestDone();
            this.hideConfirmationDialog();
        });
    }
    goToLink(external, link) {
        this.menu = false;
        if (external) {
            window.open(link);
        }
    }
    mounted() {
        Provider.initialize();
    }
};
__decorate([
    Getter('token', { namespace: 'session' })
], HelpCenterWidget.prototype, "token", void 0);
__decorate([
    Getter('role', { namespace: 'session' })
], HelpCenterWidget.prototype, "role", void 0);
HelpCenterWidget = __decorate([
    Component({
        components: {
            ResetPermissionDialog: () => import('@/components/BaseConfirmDialog.vue'),
            PasswordDialog: () => import('@/components/ResetPermissionPasswordDialog.vue'),
            MerchantSpace: () => import('./MerchantSpace.vue'),
        },
    })
], HelpCenterWidget);
export default HelpCenterWidget;
